import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'
import { Color } from 'zens-storybook'

export interface Props extends SvgProps {
  size?: number
}
const FloorplanDesk = (props: Props) => {
  const { size = 48, color, ...otherProps } = props

  const width = Math.min(size, (size * FloorplanDesk.dimensions.width) / FloorplanDesk.dimensions.height)
  const height = Math.min(size, (size * FloorplanDesk.dimensions.height) / FloorplanDesk.dimensions.width)

  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${FloorplanDesk.dimensions.width} ${FloorplanDesk.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill="none"
        stroke={Color.premiumBlack}
        strokeWidth={0.4}
        d="M16.6 2.604V.396A.29.29 0 0 1 16.881.1H31.12a.29.29 0 0 1 .281.296v2.208a.29.29 0 0 1-.281.296H16.88a.289.289 0 0 1-.281-.296Z"
      />
      <Path
        fill={color || Color.sleepingGrey}
        stroke={Color.premiumBlack}
        strokeWidth={0.4}
        d="M3.437 5.2h41.126a.75.75 0 0 1 .737.761V23.04a.75.75 0 0 1-.737.761H3.437a.75.75 0 0 1-.737-.761V5.96a.75.75 0 0 1 .737-.761Z"
      />
    </Svg>
  )
}

FloorplanDesk.dimensions = {
  width: 48,
  height: 24,
}

export default FloorplanDesk
